export default __webpack_public_path__ + "static/media/10.cca6dc85.jpg";